import React from "react";
import { Carousel } from "react-responsive-carousel";
import "./react-responsive-carousel.scss";
import "./react-videoplayer/lib/index.scss";
import uuidv4 from "uuid/v4";
import { AudioFile, dragDrop } from "../../../assets/images";
import "../../../assets/scss/image-gallery-custom.scss";
import Config from "../../../config";
import { INLINE_FLEX } from "../../../Helpers/Constants";
import { 
  getThumbBase64URL, 
  blockOfflineMsgAction, 
  getMessageType,
  millisToMinutesAndSeconds
} from "../../../Helpers/Utility";
import { 
  sendErrorMessage,
  // getExtension,
  // sendErrorMessage,
  validateFile
} from "../../WebChat/Common/FileUploadValidation";
import "./media-attachment.scss";
import PreviewComponent from "./previewComponent";

const MediaPreview = ((props = {}) => {
  const { seletedFiles = {} } = props;  
  const [getMediaPreview, setMediaPreview] = React.useState({
    mediaList: [],
    previewData: [],
    selectedFiles: [],
    isZoomed: false,
    initialLoad:false,
    imageType:"", 
    videoProgress: 0,
    imageRemove : false,
    videoDuration: "",
    selectedSlide: 0
  });
  const [ sendClick,setSendClick ] = React.useState(false)
  const [ eventFiles,setEventFiles ] = React.useState([])
  const [ mediaData , setMediaData ] = React.useState({
    mediafiles: []
  })

  let Previous = React.useRef(null);
  let Next = React.useRef(null);
  const {  selectedFiles = [], selectedSlide } = getMediaPreview;

  window.URL = window.URL || window.webkitURL;
  const maxAllowedMediaCount = Config.maxAllowedMediaCount;
  // Temporary state to hold the files
  // const [tempFiles, setTempFiles] = React.useState(null);
  // React.useEffect(() => {
  //   if (tempFiles) {
  //       const { seletedFiles: { mediaType } = {} } = props;
  //       handleFiles(tempFiles, mediaType);
  //       // Clear the temporary files after processing
  //       setTempFiles(null);
  //   }
  // }, [tempFiles]);
  React.useEffect(() => {
    const { filesId = "", mediaType = "", files = []} = seletedFiles;
    if (!filesId) return;
    document.addEventListener("keydown", handleKeyboardActions, { passive: false});
    handleFiles(files, mediaType);
    handleToast(files)
    return (() => {
      window.document && document.removeEventListener("keydown", handleKeyboardActions, { passive: true});
    });
  },[]);
  
  React.useEffect(() => {
    const { files = [] } = seletedFiles;
      handleFiles(files, "");
  },[getMediaPreview.selectedFiles?.fileId]);
  
  React.useEffect(()=>{
    handleImage()
    if(getMediaPreview.selectedFiles.length === 0 && getMediaPreview.imageRemove)
      closePreview()
  },[getMediaPreview.selectedFiles])
  
  React.useEffect(()=>{
    if(sendClick){
      sendMediaFile()
    }
  },[sendClick])

  React.useEffect(()=>{
    handleFiles(eventFiles, "media", "new");
    handleToast(eventFiles)
  },[eventFiles])

  React.useEffect(()=>{
    const uploadcontainer = document.getElementById("dynamicUpload");
    if (uploadcontainer) uploadcontainer.style.display = INLINE_FLEX;
    handleImage()
  },[getMediaPreview.imageRemove])

  React.useEffect(()=>{
    const thumbsWrapper = document.querySelector(".thumbs-wrapper");
    const uploadcontainer = document.getElementById("dynamicUpload");
      if (thumbsWrapper && !uploadcontainer) {
        createAddFileContainer(thumbsWrapper);
      } 
      else {
      if (uploadcontainer)
        uploadcontainer.style.display = selectedFiles.length >= maxAllowedMediaCount
        ? "none" : INLINE_FLEX;
      }   
  },[getMediaPreview.previewData])

  const handleKeyboardActions = (e) => {
    switch (e.keyCode) {
      case 13:
        !e.shiftKey && setSendClick(true);
        break;
      case 27:
        closePreview();
        break;
      case 37:
        let getActiveClass = document.getElementById("imagePreviewContainer").querySelector(".incaption");
        !getActiveClass && Previous.current && Previous.current.click();
        break;
      case 39:
        let rigthActiveClass = document.getElementById("imagePreviewContainer").querySelector(".incaption");
        !rigthActiveClass && Next.current && Next.current.click();
        break;

      default:
        break;
    }
  };

  const createAddFileContainer = (thumbsWrapper) => {
    let child = document.createElement("div");
    child.innerHTML = `<div id="dynamicUpload" class="uploadfile" style="display: ${
      selectedFiles.length >= maxAllowedMediaCount ? "none" : INLINE_FLEX
    }">
            <div><label for="addfile"><input id="addfile" class="uploadfileinput" type="file" multiple /></label>
            <span style= "font-size:24px"> + </span> <span>ADD FILE</span></div></div>`;
    child = child.firstChild;
    child.querySelector(".uploadfileinput").addEventListener("change", (event) => {
      setEventFiles(
        event.target.files
      )
    });
    thumbsWrapper.appendChild(child);
    let sendButtonChild = document.createElement("div");
    sendButtonChild.innerHTML = `<div class="attachmentSend"><i>
    <svg fill="#fff" width="26.705" height="25.802" viewBox="0 0 26.705 25.802"><path d="M0,64.052l26.7-12.9L0,38.25v11l14.525,1.905L0,53.057Z" 
    transform="translate(0 -38.25)"></path></svg></i></div>`;
    sendButtonChild = sendButtonChild.firstChild;
    sendButtonChild.querySelector("i").addEventListener("click", (event) => {
      /**
      // sendMediaFile();
      */
      if(blockOfflineMsgAction()) return false;
      setSendClick(true)
    });
    thumbsWrapper.parentElement.appendChild(sendButtonChild);
  };

  /**
   * @param {any} files - Selected Files
   * @param {any} mediaType - To Handle Corresponding Error Message for Different Medias
   * @param {any} type - To Handle Selected Slides When New Media Added
   */
  const handleFiles = (files, mediaType, type) => {
    let filesArray = Array.from(files);
    validateFile(filesArray, mediaType)
      .then((res) => {
        res.map((response)=>{
          if(!response && selectedFiles.length === 0) closePreview()
        })
        const filterValid = filesArray.filter((file, index) => {
          return res.find((ele, responseIndex) => responseIndex === index && ele);
        });

        setMediaPreview(
          { ...getMediaPreview,
            showAvailableOptions: false,
            imageType : type ? type : "",
            initialLoad : true,
            selectedFiles: [
              ...getMediaPreview.selectedFiles,
              ...filterValid.map((file,i) => {
                let fileId = uuidv4();
                file.fileDetails = {
                  fileId: fileId,
                  imageUrl: seletedFiles.mediaType === "imagevideo" ||
                            getMessageType(files[i].type, files[i]) === "image" ? URL.createObjectURL(files[i]) : "",
                  msgType: seletedFiles.mediaType ? seletedFiles.mediaType : getMessageType(files[i].type, files[i])
                };
                return file;
              })
            ].slice(0, maxAllowedMediaCount)
          })  
      })
      .catch((err) => console.log(err, "upload file error"));
  };

  const handleToast = (files)=>{
    if (files.length + getMediaPreview.selectedFiles.length > maxAllowedMediaCount) {
      sendErrorMessage();
    }
  }
  // const onDragOver = (event) => {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   const imagePreviewContainer = document.getElementById("imagePreviewContainer");
  //   imagePreviewContainer && imagePreviewContainer.classList.add("highlight");
  //   return false;
  // };
  // const onDrop = (e) => {
  //   e.preventDefault();
  //   const { seletedFiles: { mediaType } = {} } = props;
  //   let files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
  //   const imagePreviewContainer = document.getElementById("imagePreviewContainer");
  //   imagePreviewContainer && imagePreviewContainer.classList.remove("highlight");
  //   if (files) {
  //     const newDraggedFiles = {
  //       dragId: uuidv4(),
  //       files: files
  //   };
  //   setMediaPreview((prev) => ({
  //       ...prev,
  //       draggedFiles: newDraggedFiles
  //   }));
  //   // Using a temporary variable to capture the files for useEffect
  //   setTempFiles(files);
  //   }
  // };
  const handleImage=()=>{
    setMediaPreview(
      { ...getMediaPreview,
        previewData: PreviewComponent(getMediaPreview.selectedFiles,onChangeCaption,sendMediaFile,updateMedia),
        // ...(getMediaPreview.imageType === "new" && 
        // { selectedSlide: getMediaPreview.selectedFiles.length }
        // )
      })
  }

  const removeSelectedItem = (deleteThis) => {
    let index = selectedFiles.indexOf(deleteThis);
    const filterItem = selectedFiles.filter((elem, i) => i !== index);
    let newActiveSlide = selectedSlide !== 0 && selectedSlide === filterItem.length ? selectedSlide - 1 : selectedSlide;

    setMediaPreview(
      { ...getMediaPreview,
        selectedFiles: filterItem,
        selectedSlide: newActiveSlide,
        imageRemove : true
      })
  };

  const onChangeCaption = (updateThis = {}, caption = "") => {
    let temp = document.createElement("div");
    temp.innerHTML = caption;
    let sanitized = temp.textContent || temp.innerText;
    updateThis.caption = sanitized
    return true;
  };

  const updateMedia = (updateThis, fileMetaData) => {
    let index = selectedFiles.indexOf(updateThis);
    const updateItem = selectedFiles.map((element, i) => {
      if (i === index) {
        element.fileDetails = {
          fileId: updateThis?.fileDetails?.fileId,
          ...fileMetaData
        };
      }
      return element;
    });
    setMediaData({ ...mediaData,
      mediafiles: updateItem,
    });
  };


  const sendMediaFile = () => {
    if(blockOfflineMsgAction()) return false;
    // Restricting the Send if Thumb is not Loaded for Image and Video
    const found = getMediaPreview.selectedFiles.filter((el) => {
      const {
        fileDetails: { msgType, imageUrl:imageUrlSendFile }
      } = el;
      return !((!msgType || msgType === "image" || msgType === "video ") && !imageUrlSendFile);
      // // if ((!msgType || msgType === "image" || msgType === "video ") && !imageUrlSendFile) return false;
      // // return true;
    });
    if (found.length !== getMediaPreview.selectedFiles.length) return true;
    
    props.onClickSend(getMediaPreview.selectedFiles);
    return true
  };

  const handleMediaOnChange = (index, item) => {
    setMediaPreview({ 
      ...getMediaPreview,
      selectedSlide: index });
    document
      .getElementById("imagePreviewContainer")
      .querySelectorAll("video, audio")
      .forEach((element) => element.pause());
  };



  const closePreview = () => {
    props.onClosePreview();
  };

  const getSrcDocument = (thumb, placeholder) => {
    if (thumb === "file") {
      return placeholder;
    }
    return AudioFile;
  };

  const imageOnLoad = (e) => {
    e.target.classList.remove("image-load");
    e.target.style.display = "block";
  };

  const handlePrev = (onClickHandler, hasPrev) => {
    return (
      hasPrev && (
        <button
          type="button"
          onClick={onClickHandler}
          title="Previous"
          ref={Previous}
          aria-label="previous slide / item"
          className="control-arrow control-prev"
        ></button>
      )
    );
  };


  const handleNext = (onClickHandler, hasNext) => {
    return (
      hasNext && (
        <button
          type="button"
          onClick={onClickHandler}
          title="Next"
          ref={Next}
          aria-label="next slide / item"
          className="control-arrow control-next"
        ></button>
      )
    );
  };

  /**
  // const imageOnLoader = (e) => {
  //   e.target.style.display = "none";
  // };
  */

  const getMediaSrc = (thumb, placeholder, imageUrlGetMediaSrc) => {
    let mediaSrc;

    switch (thumb) {
      case "file":
      case "audio":
        mediaSrc = getSrcDocument(thumb, placeholder);
        break;

      case "video":
        mediaSrc = getThumbBase64URL(imageUrlGetMediaSrc);
        break;

      case "image":
        mediaSrc = imageUrlGetMediaSrc;
        break;

      default:
        break;
    }

    return mediaSrc;
  };

  const customRenderThumb = (children) => {
      return children.map((item, index) => {
          const {
            placeholder,
            thumb,
            media: {
              fileDetails: { fileId, imageUrl:imageUrlThumb = "",duration }
            }
          } = item.props;
    
          const mediaSrc = getMediaSrc(thumb, placeholder, imageUrlThumb);
    
          return (
            <div key={fileId} className={thumb === "file" ? "thumb-img file img-load" : "thumb-img img-load"}>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  removeSelectedItem(item.props.media);
                }}
                title="Remove"
                className="removeSelected"
              ></span>
              <img
                src={mediaSrc}
                key={`${fileId}-Img`}
                alt=""
                onLoad={imageOnLoad}
                className="image-load"
                style={{ display: "none" }}
              />
              {/* <Spinner /> */}
              {duration && (
                <p className={`${thumb === "video" ? "video-duration" : "audio-duration"}`} key={`${fileId}-Duration`}>
                  {millisToMinutesAndSeconds(duration)}
                </p>
              )}
            </div>
          );
        });
    };
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <React.Fragment>
          <div
            // onDrop={onDrop}
            // onDragOver={onDragOver}
            className="imagePreviewContainer mediaAttachmemtUpload"
            id="imagePreviewContainer"
          >
            <div className="attachments-header">
              <h5>Preview</h5>
              <i onClick={() => closePreview()}>
                <svg width="24px" height="24px" viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </i>
            </div>
            {selectedFiles.length > 0 ? (
              <Carousel
                renderArrowPrev={handlePrev}
                renderArrowNext={handleNext}
                selectedItem={getMediaPreview.selectedSlide}
                onChange={handleMediaOnChange}
                onClickThumb={handleMediaOnChange}
                renderThumbs={customRenderThumb}
                interval="100"
                transitionTime="10"
                thumbWidth="80"
                swipeable={false}
                showThumbs={true}
              >
                {getMediaPreview.previewData}
              </Carousel>
             ) : (
              <div className="drag-preview">
                <div className="drag-area">
                  <div>
                    <div className="drag-area-inner">
                      <span>
                        <img src={dragDrop} alt="Drag and Drop" />
                      </span>
                      <h1>Drag &amp; Drop Your Files Here</h1>
                      <p>
                        Make sure to upload a 'JPG, JPEG, PNG, MP3, MP4, PDF, XLS, XLSX, DOC, DOC, PPT, PPTX, RAR, ZIP,
                        CSV or TXT' file
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </React.Suspense>
    );
});

export default React.memo(MediaPreview);